/*
 * TUTIE. no:wa — 予約解禁カウントダウン（2026-06-19）
 * 商品メタフィールド custom.release_at（date_time）を data-release-at として受け取り、
 * 解禁の瞬間に「COMING SOONバナー → 購入フォーム」を端末時計でピッタリ差し替える。
 * cron/GASのトリガー粒度に依存せず、Shopifyのページキャッシュの影響も受けない。
 *
 * 対象DOM（buy-buttons.liquid が gate_mode=scheduled のとき出力）:
 *   <div ... data-release-at="2026-07-03T12:00:00+0900">
 *     <div class="tutienowa-preorder-banner" data-release-banner> ... <span data-release-date></span> ... </div>
 *     <div data-release-buybox hidden> <product-form> ... </product-form> </div>
 *   </div>
 */
(function () {
  var MAX_DELAY = 2147483647; // setTimeout の上限（約24.8日）

  function reveal(banner, buybox) {
    if (banner) banner.style.display = 'none';
    if (buybox) {
      buybox.hidden = false;
      buybox.removeAttribute('hidden');
    }
  }

  function gate(banner, buybox) {
    if (banner) banner.style.display = '';
    if (buybox) buybox.hidden = true;
  }

  function fillDate(root, releaseMs) {
    var dateEl = root.querySelector('[data-release-date]');
    if (!dateEl) return;
    try {
      dateEl.textContent = new Date(releaseMs).toLocaleString('ja-JP', {
        month: 'long',
        day: 'numeric',
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch (e) {
      /* ロケール未対応環境はLiquidのフォールバック表記をそのまま使う */
    }
  }

  function init(root) {
    if (root.__preorderInit) {
      // 再初期化時は既存タイマーを破棄
      if (root.__preorderTimer) clearTimeout(root.__preorderTimer);
    }
    root.__preorderInit = true;

    var at = root.getAttribute('data-release-at');
    if (!at) return;
    var releaseMs = new Date(at).getTime();
    if (isNaN(releaseMs)) return;

    var banner = root.querySelector('[data-release-banner]');
    var buybox = root.querySelector('[data-release-buybox]');

    fillDate(root, releaseMs);

    var now = Date.now();
    if (now >= releaseMs) {
      reveal(banner, buybox);
      return;
    }

    gate(banner, buybox);
    var delay = releaseMs - now;
    if (delay > MAX_DELAY) return; // 遠すぎる場合は次回ロード時にサーバ判定へ委ねる
    root.__preorderTimer = setTimeout(function () {
      reveal(banner, buybox);
    }, delay);
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-release-at]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  // 初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // バリアント変更でセクションが再描画された場合に再初期化（Dawn の pub/sub）
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      // 再描画後のDOMに対して再適用
      setTimeout(boot, 0);
    });
  }
})();
